/* eslint-disable no-plusplus */
/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/*
 * @Author: Kuaiyin FE
 * @Date: 2020-10-14 19:12:27
 * @Description: 生成请求签名模块
 * @FilePath: /vision-h5/src/service/sign.js
 */

import Qs from 'qs';
import md5 from 'md5';
import { versionCompare } from '@/lib/common';
import sdk from '../sdk';
import { trackClick } from '@/lib/track';
import platform from '@/lib/platform';

// 定义签名序列
const sig1 = [82, 116, 102, 123, 68, 120, 122, 43, 125, 117, 89, 48, 92, 94, 50, 129, 99, 126, 94, 84];
const proj = [107, 118, 99, 108, 125, 110, 116, 102, 112, 62];

/**
 * @description: 排序方法：根据首字母的 Unicode 编码大小进行比对排列，首字母相同时进行递归操作
 * @param {string} k1 - 第一个参数
 * @param {string} k2 - 第二个参数
 * @return: void
 */

const _keySort = (k1, k2) => {
	const c1 = k1 && k1.charAt(0) ? k1.charAt(0).charCodeAt() : 0;
	const c2 = k2 && k2.charAt(0) ? k2.charAt(0).charCodeAt() : 0;
	if (!c1 && !c2) {
		return 0;
	}
	if (c1 === c2) {
		return _keySort(k1.substring(1), k2.substring(1));
	}
	return c1 - c2;
};

/**
 * @description: 对数组进行 key => value 排序
 * @param {object} params - 请求参数
 * @return: sortedArr{Array}
 */

const _sortKeyValue = (params) => {
	const keys = Object.keys(params);
	keys.sort(_keySort);
	return keys;
};

/**
 * @description: 签名并字符串化数据
 * @param {object} params - 请求参数
 * @param {string} origin - 请求来源
 * @return: res{String}
 */

const signAndStringifyData = (params, origin) => {
	// 声明签名结果对象
	let res = {};

	const data = { ...params };
	const client = data.client_v;

	// 根据模块类型配置条件版本号
	const startVersion = origin === 'GAME_REQUEST' ? '2.8.2' : '2.8.0';
	const exceptVersion = '2.10.4';

	// 增加项目印记
	const ts = Math.floor(new Date().getTime() / 1000);
	const isTandS = Boolean(
		origin === 'CLIENT_REQUEST' || (client && versionCompare(client, startVersion) !== -1 && versionCompare(client, exceptVersion))
	);
	if (isTandS) {
		data.t = ts;
	} else {
		data.sig_ts = ts;
	}

	// 配置签名参数
	let k = 0;
	data.proj = proj.reduce((r, i) => {
		return `${typeof r == 'string' ? r : String.fromCharCode(r - k++)}${String.fromCharCode(i - k++)}`;
	});

	// 请求参数以key值排序
	const keys = _sortKeyValue(data);

	// 生成排序后的参数键值对字符串数组
	let md5s = [];

	keys.map((k) => {
		if (data[k] !== null && data[k] !== undefined) {
			res[k] = data[k];
			let v = res[k];
			if (typeof v == 'object') {
				v = JSON.stringify(v);
			}
			v = encodeURIComponent(v);
			md5s.push(`${k}=${v}`);
		}
	});

	// 判断版本号，采用不同的签名方式
	if (isTandS) {
		// 调用客户端签名方法
		const sign = sdk.appCall('SIGN_CONTENT', decodeURIComponent(md5s.join('&')));
		res.s = sign;

		if (!res.s) {
			let haveSignMethod = '';
			if (platform.platform === 'ios') {
				haveSignMethod = window.dsBridge && window.dsBridge.hasNativeMethod('signContent');
			} else if (platform.platform === 'android') {
				haveSignMethod = window.bridge && !!window.bridge.signContent;
			}
		}
	} else {
		// 用md5进行签名
		k = 0;
		let sig = sig1.reduce((r, i) => {
			return `${typeof r == 'string' ? r : String.fromCharCode(r - k++)}${String.fromCharCode(i - k++)}`;
		});

		res.sig = md5(sig + '&' + md5s.join('&'));
	}
	return Qs.stringify(res);
};

export default signAndStringifyData;



// WEBPACK FOOTER //
// ./src/service/sign.js